import React, { useState, useEffect } from "react";
import { Inner } from "./styles";
import { Form, Button, Select, Divider } from "antd";

import { Footer } from "../../../../styles";
import FloatingLabel from "../../../../../floatingLabel/FloatingLabel";
import { ButtonsFixedFooter, Buttons } from "../../styles";
import { get_currencies } from "../../../../../../../api/endpoints/sysone-endpoints/sysoneEndpoints";

const { Option } = Select;

export default function CreatePaymentCash({
	onCreate,
	setAddPaymentMethodMode,
	fixedFooter
}) {

	const [form] = Form.useForm();
	const [currencies, setCurrencies] = useState([]);

	const cash_currency = Form.useWatch("cash_currency", form);

	useEffect(() => {
		const fetch_currencies = async () => {
			const data = await get_currencies()
			setCurrencies(data.values || []);
		};

		fetch_currencies();
	}, []);

	const resetForm = () => {
		form.resetFields();
	};

	const onFinish = async (values) => {
		try {
			const post_data = {
				currencyCode: values.cash_currency,
				currencyName: currencies.find((i) => i.code === values.cash_currency)
					.name,
				type: "cashMethodData",
			};

			resetForm();
			onCreate(post_data);
		} catch (error) {
			console.error(error);
		}
	};

	return (
		<Inner>
			<Form
				form={form}
				name="create-debit-form"
				layout="vertical"
				onFinish={onFinish}
			>
				<FloatingLabel
					label={"Moneda"}
					value={cash_currency}
					hint={"Moneda"}
				>
					<Form.Item
						name="cash_currency"
						rules={[
							{
								required: true,
								message: "Campo requerido",
							},
						]}
					>
						<Select
							allowClear={true}
							disabled={!currencies || currencies?.length === 0}
						>
							{currencies.map((currency) => (
								<Option key={currency.code} value={currency.code}>
									{currency.name}
								</Option>
							))}
						</Select>
					</Form.Item>
				</FloatingLabel>

				{fixedFooter ? (
					<Footer>
						<Divider />
						<ButtonsFixedFooter>
							<Button
								type="secondary"
								onClick={() => setAddPaymentMethodMode(false)}
								htmlType="button"
							>
								{"Cancelar"}
							</Button>
							<Button type="primary" htmlType="submit">
								{"Agregar"}
							</Button>
						</ButtonsFixedFooter>
					</Footer>
				) : (
					<Buttons>
						<Button
							type="secondary"
							onClick={() => setAddPaymentMethodMode(false)}
							htmlType="button"
						>
							{"Cancelar"}
						</Button>
						<Button type="primary" htmlType="submit">
							{"Agregar"}
						</Button>
					</Buttons>
				)}
			</Form>
		</Inner>
	);
}
